import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Table, Badge, Button } from 'react-bootstrap';
import ProjectContext from '../context/ProjectContext';
import AuthContext from '../context/AuthContext';

const Documents = () => {
  const { activeProject } = useContext(ProjectContext);
  const { user } = useContext(AuthContext);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (activeProject && user?.type === 'admin') {
      fetchDocuments();
    } else if (activeProject && user?.type && user?.type !== 'admin') {
      setLoading(false);
      setError('Access denied: Admin role required');
    }
  }, [activeProject, user]);

  const fetchDocuments = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`/api/projects/${activeProject._id}/documents`);
      setDocuments(res.data);
    } catch (err) {
      console.error(err);
      setError('Failed to load documents');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-5 text-center">
        <div className="spinner-border text-primary" role="status"></div>
        <p className="mt-2 text-muted">Loading documents...</p>
      </div>
    );
  }

  if (error) {
    return <div className="p-5 text-center text-danger h5">{error}</div>;
  }

  if (!activeProject) {
    return <div className="p-5 text-center">Please select a project first.</div>;
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Project Documents</h1>
        <div>
          <Badge variant="info" className="mr-2">ID: {activeProject._id}</Badge>
          <Badge variant="primary">{activeProject.name}</Badge>
        </div>
      </div>

      <div className="card shadow-sm border-0">
        <Table hover responsive className="mb-0">
          <thead className="thead-light">
            <tr>
              <th>File Name</th>
              <th>Account</th>
              <th>Type</th>
              <th>Size</th>
              <th>Uploaded By</th>
              <th>Date</th>
              <th className="text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {documents.length > 0 ? (
              documents.map(doc => (
                <tr key={doc._id}>
                  <td className="small font-weight-bold">
                    <i className="far fa-file-pdf text-danger mr-2"></i>
                    {doc.originalName}
                  </td>
                  <td className="small">{doc.accountId?.name || '-'}</td>
                  <td><Badge variant="secondary">{doc.type}</Badge></td>
                  <td className="small text-muted">{(doc.size / 1024).toFixed(1)} KB</td>
                  <td className="small">{doc.uploadedBy?.name}</td>
                  <td className="small">{new Date(doc.createdAt).toLocaleDateString()}</td>
                  <td className="text-right">
                    <Button variant="link" size="sm" onClick={() => window.open(`/${doc.path}`, '_blank')}>
                      View
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center p-4 text-muted">
                  No documents found for this project.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default Documents;
